import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// 🔥 GLOBAL PWA install event capture
window.deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  console.log("🔥 PWA install prompt captured globally");
  window.deferredPrompt = e;
  window.dispatchEvent(new Event("pwa-prompt-ready"));
});

// React render
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register Service Worker for PWA installability & offline support
serviceWorkerRegistration.register();
